import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon-arrow-right-active.svg'


const _hoisted_1 = { class: "widget-main" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["swidth", "onClick"]
const _hoisted_4 = {
  key: 1,
  class: "no-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableCell = _resolveComponent("TableCell")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_widget_layout = _resolveComponent("widget-layout")!

  return (_openBlock(), _createBlock(_component_widget_layout, {
    class: _normalizeClass(["user-welcome", `width${_ctx.width}`]),
    minHeight: 2,
    maxHeight: 2,
    maxWidth: 2,
    loading: !_ctx.data,
    menuColour: "#fff"
  }, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "title" }, [
        _createElementVNode("h4", null, "User welcome emails")
      ], -1),
      _createElementVNode("div", { class: "description" }, [
        _createElementVNode("p", null, "A list of users that have not been sent a welcome email")
      ], -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.usersData && _ctx.usersData.length)
            ? (_openBlock(), _createBlock(_component_TableList, {
                key: 0,
                tableName: "users",
                totalRows: _ctx.usersData ? _ctx.usersData.length : 0,
                currentPage: _ctx.currentPage,
                paginated: false,
                showTableSelection: false,
                customClass: "new-style no-top-border"
              }, {
                colspan: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("colgroup", null, [
                    _createElementVNode("col", { style: {"width":"15%"} }),
                    _createElementVNode("col", { style: {"width":"40%"} }),
                    _createElementVNode("col", { style: {"width":"30%"} }),
                    _createElementVNode("col", { style: {"width":"15%"} })
                  ], -1)
                ]))]),
                head: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, " "),
                      _createElementVNode("th", { class: "text-left" }, "User"),
                      _createElementVNode("th", null, "Email Sent"),
                      _createElementVNode("th", null, " ")
                    ])
                  ], -1)
                ]))]),
                body: _withCtx(() => [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (row, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.id,
                        class: _normalizeClass(["row", {
                    alternate: _ctx.isOdd(i),
                  }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col) => {
                          return (_openBlock(), _createBlock(_component_TableCell, {
                            dataType: col.dataType,
                            data: col.data,
                            dataInfo: col.dataInfo,
                            key: col.id,
                            onClickCell: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId)),
                            onClickRow: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId))
                          }, null, 8, ["dataType", "data", "dataInfo", "onClickCell", "onClickRow"]))
                        }), 128)),
                        _createElementVNode("td", {
                          class: "td-button",
                          swidth: 100 / (row.cols.length + 1) + '%',
                          onClick: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId))
                        }, [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "",
                            style: {"height":"14px","width":"7px"}
                          }, null, -1)
                        ]))], 8, _hoisted_3)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["totalRows", "currentPage"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, " There are no users awaiting a welcome email "))
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "class"]))
}